// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"EditControlsTemperatureForm_tabContent__1f042"};